import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { provideTranslation } from './shared/localization/translate-provider';
import { provideLanguageInitializer } from './shared/localization/language-initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideTranslation(),
    provideLanguageInitializer(),
    provideZoneChangeDetection({ eventCoalescing: true }),
  ],
};


